module.exports = __webpack_public_path__ + "static/media/115.2063cb83.jpg";